import request from "@/utils/request";

export default function getAppidByAgentCode(
  agentCode = "06595eebe6c140c4b63828d7d1ab8ead"
) {
  return request({
    url: `/user/agent/getAppidByAgentCode?agentCode=${agentCode}`,
    method: "get",
  });
}
